export enum AppViews {
  simulation = 'simulation',
  performance = 'performance',
  configuration = 'configuration',
  examples = 'examples'
}
